module.exports = __webpack_public_path__ + "img/cloudy.bdfd9066.svg";